import { create } from "zustand";
import { formTagApi } from "../services/form-tag-api";
import type { AxiosResult } from "@/lib/axios";

interface FormTagState {
	attach: (workspaceId: string, formId: string, tagId: string) => Promise<AxiosResult<void>>;
	detach: (workspaceId: string, formId: string, tagId: string) => Promise<AxiosResult<void>>;
	sync: (workspaceId: string, formId: string, tagIds: string[]) => Promise<AxiosResult<void>>;
}

export const useFormTagStore = create<FormTagState>(() => ({
	attach: async (workspaceId: string, formId: string, tagId: string) => {
		const response = await formTagApi.attach(workspaceId, formId, tagId);
		return response;
	},

	detach: async (workspaceId: string, formId: string, tagId: string) => {
		const response = await formTagApi.detach(workspaceId, formId, tagId);
		return response;
	},

	sync: async (workspaceId: string, formId: string, tagIds: string[]) => {
		const response = await formTagApi.sync(workspaceId, formId, tagIds);
		return response;
	},
}));
